var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancelDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 104,
    width: 513,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-82 -104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 53.3333C144.038 53.301 53.2484 144.038 53.216 256 53.1836 367.962 143.921 458.751 255.883 458.784 367.845 458.817 458.634 368.079 458.667 256.117 458.667 256.096 458.667 256.075 458.667 256.053 458.725 144.153 368.06 53.392 256.16 53.3333 256.107 53.3333 256.053 53.3333 256 53.3333ZM256 448.112C149.929 448.145 63.9152 362.183 63.8827 256.112 63.8501 150.041 149.812 64.0272 255.883 63.9947 361.954 63.9621 447.967 149.924 448 255.995 448 256.02 448 256.044 448 256.069 447.894 362.074 362.004 447.99 256 448.128Z",
    stroke: "#000000",
    strokeWidth: 17.3333,
    transform: "matrix(1.00195 0 0 1 82 104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.885 173.637 255.989 248.533 181.093 173.637 173.552 181.179 248.448 256.075 173.552 330.971 181.093 338.512 255.989 263.616 330.885 338.512 338.427 330.971 263.531 256.075 338.427 181.179 330.885 173.637Z",
    stroke: "#000000",
    strokeWidth: 17.3333,
    transform: "matrix(1.00195 0 0 1 82 104)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelDark);
export default __webpack_public_path__ + "static/media/cancel_dark.01d58ab1a4b58d0583d7c251d23a9b36.svg";
export { ForwardRef as ReactComponent };